import React from 'react';
import TableData from './TableData';
import editIcon from '../../assets/svg/edit.svg';

function TableRow({
  data,
  width,
  identifier,
  onEdit,
  onDelete,
  onView,
  onYes,
  onNo,
  onApprove,
  isYesNoEnabled,
  isDeleteEnable,
  isImportEnable,
  onImport,
  isViewEnable,
  isChangeStatusEnable,
  onChangeStatus,
  isEditEnable,
  handleRowClick,
  onAccept,
  isAcceptEnable,
  isCancelDeal,
  onCancelDeal,
  onCancel,
  isCancelEnable,
  onViewBrands,
  onViewItems,
  isStatusUpdateEnable,
  onStatusUpdate,
  isMarkEnable,
  onMark,
  isDollerEnable,
  onDollor,
  onViewByName,
  isViewByName,
  rowName,
  isBtnEnable,
  onBtn,
  datashowbtn,
  onViewNote,
  isDownloadInvoiceEnable,
  onDownloadInvoice,
  isDownloadBillEnable,
  onDownloadBill,
  onResendInvite,
  onViewManager,
  onViewSalesExec,
  isInventoryActionEnabled,
  onInventoryPurchase,
  onInventoryUpdate,
  onDownloadDoc,
  isDownloadDocEnable,
  onUploadDoc,
  uploadDocId,
  onDownloadSignDoc,
  isDownloadSampleDocEnable,
  onDownloadSampleDoc,
  className = ''
}) {
  // Handle row click with check to prevent triggering when clicking on action buttons
  const handleRowClickWrapper = (e) => {
    // Check if the click is coming from an action button
    if (e.target.closest('.action-button')) {
      // If it is, don't trigger the row click
      return;
    }

    // Otherwise, trigger the row click handler
    if (handleRowClick) {
      handleRowClick(data[identifier]);
    }
  };

  return (
    <div
      className="flex flex-wrap max-w-full justify-between border-b-[1px] p-4 cursor-pointer hover:bg-gray-50 transition-all duration-200"
      onClick={handleRowClickWrapper}>
      {Object.keys(data)
        ?.filter((key) => !key.startsWith('_'))
        ?.map((item, index) =>
        data?.[item] === 'Actions' ||
        data?.[item] === 'YesNoOption' ||
        data?.[item] === 'Approval' ||
        data?.[item] === 'BrandList' ||
        data?.[item] === 'ItemList' ||
        data?.[item] === 'notes' ||
        data?.[item] === 'ShowPaidButton' ||
        data?.[item] === 'Invite false' ||
        data?.[item] === 'PaymentActions' ||
        data?.[item] === 'Invite true' ? (
          <TableData
            key={Math.random()}
            data={`${data[item]}---${data?.[identifier]}`}
            completeItem={data}
            identifier={identifier}
            width={width}
            alignLeft={index === 0}
            alignRight={index === Object.keys(data).length - 1}
            onEdit={onEdit}
            onDelete={onDelete}
            onView={onView}
            onYes={onYes}
            onApprove={onApprove}
            onNo={onNo}
            isYesNoEnabled={isYesNoEnabled}
            isDeleteEnable={isDeleteEnable}
            isViewEnable={isViewEnable}
            isImportEnable={isImportEnable}
            isCancelDeal={isCancelDeal}
            onCancelDeal={onCancelDeal}
            onImport={onImport}
            isEditEnable={isEditEnable}
            onAccept={onAccept}
            isAcceptEnable={isAcceptEnable}
            onChangeStatus={onChangeStatus}
            isChangeStatusEnable={isChangeStatusEnable}
            onCancel={onCancel}
            isCancelEnable={isCancelEnable}
            onViewBrands={onViewBrands}
            onViewItems={onViewItems}
            isStatusUpdateEnable={isStatusUpdateEnable}
            onStatusUpdate={onStatusUpdate}
            isMarkEnable={isMarkEnable}
            onMark={onMark}
            isDollerEnable={isDollerEnable}
            onDollor={onDollor}
            onViewByName={onViewByName}
            isViewByName={isViewByName}
            rowName={rowName}
            isBtnEnable={isBtnEnable}
            onBtn={onBtn}
            showPaidButton={data.actions === 'ShowPaidButton'}
            rowId={data?.[identifier]}
            onViewNote={onViewNote}
            isDownloadInvoiceEnable={isDownloadInvoiceEnable}
            onDownloadInvoice={onDownloadInvoice}
            isDownloadBillEnable={isDownloadBillEnable}
            onDownloadBill={onDownloadBill}
            onResendInvite={onResendInvite}
            onViewManager={onViewManager}
            onViewSalesExec={onViewSalesExec}
            isInventoryActionEnabled={isInventoryActionEnabled}
            onInventoryPurchase={onInventoryPurchase}
            onInventoryUpdate={onInventoryUpdate}
            onDownloadDoc={onDownloadDoc}
            isDownloadDocEnable={isDownloadDocEnable}
            onUploadDoc={onUploadDoc}
            uploadDocId={uploadDocId}
            onDownloadSignDoc={onDownloadSignDoc}
            isDownloadSampleDocEnable={isDownloadSampleDocEnable}
            onDownloadSampleDoc={onDownloadSampleDoc}
          />
        ) : (
          item !== identifier && (
            <TableData
              key={Math.random()}
              data={data[item]}
              completeItem={data}
              identifier={identifier}
              width={width}
              alignLeft={index === 0}
              alignRight={index === Object.keys(data).length - 1}
              onMark={onMark}
              onEdit={onEdit}
              onDelete={onDelete}
              onYes={onYes}
              onNo={onNo}
              onApprove={onApprove}
              isYesNoEnabled={isYesNoEnabled}
              onView={onView}
              isDeleteEnable={isDeleteEnable}
              isViewEnable={isViewEnable}
              isEditEnable={isEditEnable}
              onChangeStatus={onChangeStatus}
              isChangeStatusEnable={isChangeStatusEnable}
              onAccept={onAccept}
              isAcceptEnable={isAcceptEnable}
              isCancelDeal={isCancelDeal}
              onCancelDeal={onCancelDeal}
              onCancel={onCancel}
              isCancelEnable={isCancelEnable}
              isImportEnable={isImportEnable}
              onImport={onImport}
              onViewBrands={onViewBrands}
              onViewItems={onViewItems}
              isStatusUpdateEnable={isStatusUpdateEnable}
              onStatusUpdate={onStatusUpdate}
              isMarkEnable={isMarkEnable}
              isDollerEnable={isDollerEnable}
              onDollor={onDollor}
              onViewByName={onViewByName}
              isViewByName={isViewByName}
              rowName={rowName}
              isBtnEnable={isBtnEnable}
              onBtn={onBtn}
              onViewNote={onViewNote}
              isDownloadInvoiceEnable={isDownloadInvoiceEnable}
              onDownloadInvoice={onDownloadInvoice}
              isDownloadBillEnable={isDownloadBillEnable}
              onDownloadBill={onDownloadBill}
              onResendInvite={onResendInvite}
              onViewManager={onViewManager}
              onViewSalesExec={onViewSalesExec}
              isInventoryActionEnabled={isInventoryActionEnabled}
              onInventoryPurchase={onInventoryPurchase}
              onInventoryUpdate={onInventoryUpdate}
              onDownloadDoc={onDownloadDoc}
              isDownloadDocEnable={isDownloadDocEnable}
              onUploadDoc={onUploadDoc}
              uploadDocId={uploadDocId}
              onDownloadSignDoc={onDownloadSignDoc}
              isDownloadSampleDocEnable={isDownloadSampleDocEnable}
              onDownloadSampleDoc={onDownloadSampleDoc}
            />
          )
        )
      )}
    </div>
  );
}

export default TableRow;
